import { Record } from 'immutable';
import { schema } from 'normalizr';

export const SiteGroupMember = new Record({
  id: undefined,
  site: undefined,
  site_group: undefined,
  primary: undefined,
});

export const siteGroupMemberSchema = new schema.Entity('siteGroupMembers');

// for reading in nested models, object with { field: schema }
// siteGroupMemberSchema.define({  });
